/* eslint-disable import/prefer-default-export */
import client from 'core/axios';
import RequestMethod from 'core/axios/RequestMethod';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';

export const getSizeRanges = ({ version = 'v1' }) =>
  client
    .request({
      url: `${version}/org-profile/size-ranges/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getEntityTypes = ({ version = 'v1' }) =>
  client
    .request({
      url: `${version}/org-profile/entity-types/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getSectors = ({ version = 'v1' }) =>
  client
    .request({
      url: `${version}/org-profile/sectors/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getGeographicScopes = ({ version = 'v1' }) =>
  client
    .request({
      url: `${version}/org-profile/geographic-scopes/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getLocations = ({ version = 'v1' }) =>
  client
    .request({
      url: `${version}/org-profile/employer-profiles/location_options`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getProfileTypes = ({ version = 'v1' }) =>
  client
    .request({
      url: `${version}/org-profile/profile-types/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getSocialLinks = ({ version = 'v1' }) =>
  client
    .request({
      url: `${version}/org-profile/link-presets/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getSectionPresets = ({ version = 'v1' }) =>
  client
    .request({
      url: `${version}/org-profile/section-presets/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getSections = ({ version = 'v1', pk }) =>
  client
    .request({
      url: `${version}/org-profile/employer-profiles/${pk}/sections/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getShowcaseProfile = ({ version = 'v1', pk }) =>
  client
    .request({
      url: `${version}/org-profile/employer-profiles/${pk}/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getFavoriteProfiles = ({ version = 'v1' }) =>
  client
    .request({
      url: `${version}/org-profile/favorite-employer-profiles/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createFavoriteProfile = ({ version = 'v1', payload }) =>
  client
    .request({
      url: `${version}/org-profile/favorite-employer-profiles/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const deleteFavoriteProfile = ({ version = 'v1', pk }) =>
  client
    .request({
      url: `${version}/org-profile/favorite-employer-profiles/${pk}`,
      method: RequestMethod.DELETE,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getOrCreateParentProfile = ({ version = 'v1', uuid }) =>
  client
    .request({
      url: `${version}/org-profile/employer-profiles/parent-employer-profile/${uuid}/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateProfile = ({ version = 'v1', payload, profileKey }) =>
  client
    .request({
      url: `${version}/org-profile/employer-profiles/${profileKey}/`,
      method: RequestMethod.PATCH,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateEmployerProfile = ({
  version = 'v1',
  payload,
  employerUuid,
}) =>
  client
    .request({
      url: `${version}/employers/employer/${employerUuid}/`,
      method: RequestMethod.PATCH,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getEmployerList = ({ version = 'v1', params = {} } = {}) =>
  client
    .request({
      url: `${version}/org-profile/employer-profiles/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getEmployerProfile = ({ version = 'v1', employerUuid }) =>
  client
    .request({
      url: `${version}/employers/employer/${employerUuid}/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getLinks = ({ version = 'v1', pk }) =>
  client
    .request({
      url: `${version}/org-profile/employer-profiles/${pk}/links/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createLink = ({ version = 'v1', payload, profileKey }) =>
  client
    .request({
      url: `${version}/org-profile/employer-profiles/${profileKey}/links/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateLink = ({ version = 'v1', payload, profileKey, linkKey }) =>
  client
    .request({
      url: `${version}/org-profile/employer-profiles/${profileKey}/links/${linkKey}/`,
      method: RequestMethod.PATCH,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const deleteLink = ({ version = 'v1', profileKey, linkKey }) =>
  client
    .request({
      url: `${version}/org-profile/employer-profiles/${profileKey}/links/${linkKey}/`,
      method: RequestMethod.DELETE,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createSection = ({ version = 'v1', payload, profileKey } = {}) =>
  client
    .request({
      url: `${version}/org-profile/employer-profiles/${profileKey}/sections/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateSection = ({
  version = 'v1',
  payload,
  profileKey,
  sectionKey,
} = {}) =>
  client
    .request({
      url: `${version}/org-profile/employer-profiles/${profileKey}/sections/${sectionKey}/`,
      method: RequestMethod.PATCH,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

/* Doesn't yet exist in the UI but is supported by API */
export const deleteSection = ({
  version = 'v1',
  sectionKey,
  profileKey,
} = {}) =>
  client
    .request({
      url: `${version}/org-profile/employer-profiles/${profileKey}/sections/${sectionKey}/`,
      method: RequestMethod.DELETE,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getSectionImages = ({ version = 'v1', pk }) =>
  client
    .request({
      url: `${version}/org-profile/employer-profiles/${pk}/section-images/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createSectionImage = ({
  version = 'v1',
  payload,
  profileKey,
} = {}) =>
  client
    .request({
      url: `${version}/org-profile/employer-profiles/${profileKey}/section-images/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateSectionImage = ({
  version = 'v1',
  payload,
  profileKey,
  imageKey,
} = {}) =>
  client
    .request({
      url: `${version}/org-profile/employer-profiles/${profileKey}/section-images/${imageKey}/`,
      method: RequestMethod.PATCH,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateSectionImageOrder = ({
  version = 'v1',
  payload,
  profileKey,
} = {}) =>
  client
    .request({
      url: `${version}/org-profile/employer-profiles/${profileKey}/section-images/ordering/`,
      method: RequestMethod.PATCH,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const deleteSectionImage = ({
  version = 'v1',
  imageKey,
  profileKey,
} = {}) =>
  client
    .request({
      url: `${version}/org-profile/employer-profiles/${profileKey}/section-images/${imageKey}/`,
      method: RequestMethod.DELETE,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getSectionVideos = ({ version = 'v1', pk }) =>
  client
    .request({
      url: `${version}/org-profile/employer-profiles/${pk}/section-videos/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createSectionVideo = ({
  version = 'v1',
  payload,
  profileKey,
} = {}) =>
  client
    .request({
      url: `${version}/org-profile/employer-profiles/${profileKey}/section-videos/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateSectionVideo = ({
  version = 'v1',
  payload,
  profileKey,
  videoKey,
} = {}) =>
  client
    .request({
      url: `${version}/org-profile/employer-profiles/${profileKey}/section-videos/${videoKey}/`,
      method: RequestMethod.PATCH,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateSectionVideoOrder = ({
  version = 'v1',
  payload,
  profileKey,
} = {}) =>
  client
    .request({
      url: `${version}/org-profile/employer-profiles/${profileKey}/section-videos/ordering/`,
      method: RequestMethod.PATCH,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const deleteSectionVideo = ({
  version = 'v1',
  videoKey,
  profileKey,
} = {}) =>
  client
    .request({
      url: `${version}/org-profile/employer-profiles/${profileKey}/section-videos/${videoKey}/`,
      method: RequestMethod.DELETE,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getEmployerSuggestions = ({ params, version = 'v1' }) =>
  client
    .request({
      url: `${version}/employers/employer/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createEmployer = ({ payload, version = 'v1' }) =>
  client
    .request({
      url: `${version}/employers/employer/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const unauthenticatedEmployerSearch = ({ params, version = 'v1' }) =>
  client
    .request({
      url: `${version}/employers/employer/unauthenticated-search/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);
